import * as Sentry from '@sentry/react'
import { configureStore } from "@reduxjs/toolkit"
import { login } from "./actions"
import { userLoaded, setUser } from "./slices/app"
import { combineReducers } from "redux"
import createSagaMiddleware, { Saga } from "redux-saga"
import { AppState } from "./appState"
import IBReducer, { IBState } from "ib/redux/state"
import PAMMReducer, { PAMMState } from "./slices/pamm"
import rootSaga, { onStartSaga } from "./sagas"
import { registerStore } from "./storeHolder"
import * as ApiSlices from "./slices/api"
import { ApiSliceState } from "./slices/api"
import AppReducer from "./slices/app"
import DashboardReducer, { DashboardState } from "./slices/dashboard"
import LoginReducer, { LoginState } from "./slices/login"
import LoaderReducer, { LoaderState } from "./slices/loader"

const sagaMiddleware = createSagaMiddleware()

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
    stateTransformer: (state: Store) => ({
        App: {
            loggedIn: state.App.loggedIn,
            appStatus: state.App.appStatus,
            screen: state.App.screen,
        },
    }),
    actionTransformer: (action) => {
        if (action.type === login.type)
            return null
        if (action.type === userLoaded.type || action.type === setUser.type)
            return { type: action.type, payload: { id: action.payload?.id, brand: action.payload?.brand } }
        return { type: action.type }
    },
})

const middleware = [sagaMiddleware]

export type Store = {
    App: AppState
    IB: IBState
    PAMM: PAMMState
    UI: {
        Login: LoginState,
        Loader: LoaderState,
        Dashboard: DashboardState
    },
    Api: {
        Login: ApiSliceState
        Logout: ApiSliceState
        GetAccounts: ApiSliceState,
    }
}

const store = configureStore({
    reducer: {
        App: AppReducer,
        IB: IBReducer,
        PAMM: PAMMReducer,
        UI: combineReducers({
            Login: LoginReducer,
            Loader: LoaderReducer,
            Dashboard: DashboardReducer,
        }),
        Api: combineReducers({
            Login: ApiSlices.login.reducer,
            Logout: ApiSlices.logout.reducer,
            GetAccounts: ApiSlices.getAccounts.reducer,
            GetBankAccounts: ApiSlices.getBankAccounts.reducer,
            ProcessorsByAccount: ApiSlices.getProcessorsByAccount.reducer,
            WithdrawalOptions: ApiSlices.getWithdrawalOptions.reducer,
            OrganizationSettings: ApiSlices.getOrganizationSettings.reducer,
        })
    },
    middleware,
    enhancers: (defaultEnhancers) =>
        [...defaultEnhancers, sentryReduxEnhancer]
})

registerStore(store)

sagaMiddleware.run(rootSaga)
sagaMiddleware.run(onStartSaga as Saga)

export default store
